import { Component } from 'react';

/**
 * Global Error Boundary
 * Catches React render errors including chunk load failures.
 * On chunk load error, offers a reload to fetch fresh assets.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /loading chunk|failed to fetch dynamically imported module/i.test(error?.message);

    return { hasError: true, isChunkError };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "'DM Sans', sans-serif",
          background: '#fafaf9',
          padding: '2rem',
          textAlign: 'center',
        }}>
          <h1 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#1a1a2e',
            margin: '0 0 0.75rem 0',
          }}>
            {this.state.isChunkError ? 'New Version Available' : 'Something went wrong'}
          </h1>
          <p style={{
            color: '#64748b',
            marginBottom: '2rem',
            maxWidth: '400px',
            lineHeight: '1.6',
          }}>
            {this.state.isChunkError
              ? 'The app has been updated since your last visit. Please reload to get the latest version.'
              : 'An unexpected error occurred. Please reload the page to try again.'}
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: '#1a1a2e',
              color: '#fff',
              border: 'none',
              padding: '0.75rem 2rem',
              borderRadius: '0.5rem',
              fontSize: '0.95rem',
              fontWeight: '500',
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
